import React from 'react'
import './about.css'
import US from '../../assets/headerImg.jpg'

const about = () => {
  return (
    <section id='about'>
      <h5>Acerca De</h5>
      <h2>Nosotros</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={US} alt="RESISTEN" />
          </div>
        </div>

        <div className="about__content">

          <h2>COMIDAS</h2>
          <h5>Confitería & Pastelería</h5>
          
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
            when an unknown printer took a galley of type and scrambled it to make a type 
            specimen book. It has survived not only five centuries, but also the leap into 
            electronic typesetting, remaining essentially unchanged
             <a href="#contact" class="text-info text-uppercase"> nuestro local</a>.
          </p>

          <a href="#contact" className='btn btn-primary'>Contactanos</a>
        </div>
      </div>
    </section>
  )
}

export default about